import { render, staticRenderFns } from "./StockHeader.vue?vue&type=template&id=c87d2fd0"
import script from "./StockHeader.vue?vue&type=script&lang=js"
export * from "./StockHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports